import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  circle: {
    strokeLinecap: 'round',
  },
  colorPrimary: {
    color: idsTokens.progressIndicator.default.circular.color.transparent.indicator.live,
  },
  colorSecondary: {
    color: idsTokens.progressIndicator.default.circular.color.transparent.indicator.track,
    position: 'absolute',
  },
});
